import settings from '../settings.js';

const url = settings.getUrl();

export const handleLogin = async ({ email, password, csrfToken, setUser, navigate, setError }) => {
  setError('');
  try {
    if (!csrfToken) {
      setError('CSRF token is missing. Please refresh and try again.');
      console.error('CSRF token is missing for login attempt.');
      return false;
    }
    const response = await fetch(`${url}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      credentials: 'include',
      body: new URLSearchParams({
        email,
        password,
        csrf_token: csrfToken,
      }),
    });
    const data = await response.json();

    if (data.success) {
      const loggedInUser = {
        id: data.user_id,
        email: data.email,
        username: data.username,
      };
      setUser(loggedInUser);
      navigate('/accounts/balance');
      return true;
    } else {
      setError(data.error || 'Login failed.');
      return false;
    }
  } catch (error) {
    console.error('Login error:', error);
    setError('An error occurred during login.');
    return false;
  }
};
